import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { PermissionsService } from '../permissions/permissions.service';

@Injectable()
export class GroupVideosEditGuardService {
    constructor(
        private router: Router,
        private permissionsService: PermissionsService,
    ) {}

    public canActivate(route): boolean {
        if (
            !this.permissionsService.checkPermission({
                name: 'groups_videos_edit',
                schools: [route.params.school_id],
            })
        ) {
            this.router.navigate(['/error/403']);
            return false;
        }

        return true;
    }
}
